import type { Trip } from '../types/database';

type CrewFields = Pick<Trip, 'status' | 'vehicle_id' | 'driver_id'>;

export function hasFullCrew(
  trip: Pick<Trip, 'vehicle_id' | 'driver_id'>
): boolean {
  return !!(trip.vehicle_id && trip.driver_id);
}

export function resolveTripStatusAfterAssign(
  vehicleId?: string | null,
  driverId?: string | null
): 'scheduled' | 'dispatched' {
  return vehicleId && driverId ? 'dispatched' : 'scheduled';
}

export function formatCrewAssignmentLabelEn(trip: CrewFields): string {
  if (!trip.vehicle_id) return 'Awaiting vehicle';
  if (!trip.driver_id) return 'Vehicle assigned · Driver pending';
  if (trip.status === 'in_progress') return 'In progress';
  if (trip.status === 'completed') return 'Completed';
  if (trip.status === 'cancelled') return 'Cancelled';
  return 'Crew assigned';
}

export function formatCrewAssignmentLabelZh(trip: CrewFields): string {
  if (!trip.vehicle_id) return '待排车';
  if (!trip.driver_id) return '待派司机';
  if (trip.status === 'in_progress') return '行程中';
  if (trip.status === 'completed') return '已完成';
  if (trip.status === 'cancelled') return '已取消';
  return '已派车组';
}
